<div
  [class.show]="show"
  (click)="backdropAction.emit()"
  class="backdrop"
></div>
<section [class.show]="show">
  <ng-content></ng-content>
</section>
